import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IProposalStatus,
  IProposalStatusListRequest,
  ProposalStatusState,
} from "@/types/proposalStatus";
import CustomRequest from "../customRequest";

const actions: ActionTree<ProposalStatusState, RootState> = {
  // async get({ commit }, id: number) {
  //   await CustomRequest.get<IPagination<IProposalStatus>>({
  //     uri: `/proposaltatus/${id}`,
  //     commit,
  //     target: "single",
  //   });
  // },

  async getList({ commit }, params: IProposalStatusListRequest) {
    await CustomRequest.get<IPagination<IProposalStatus>>({
      uri: "/proposalStatus",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
